<template>
    <div class="inner add-propery">
        <div class="headline">
            <h1>{{ $t('property.create.headline') }}</h1>
        </div>
        <div class="content-box small">
            <div class="container">
                <h2>{{ $t('property.create.info.headline') }}</h2>
                <p>{{ $t('property.create.info.text') }}</p>
                <div class="inputs">
                    <div class="row">
                        <div class="input-container zipcode">
                            <input
                                min="1000"
                                max="9999"
                                id="zip_code"
                                type="number"
                                v-model="zip_code"
                                class="form-control"
                                name="zip_code"
                                autofocus
                                autocomplete="off"
                                autofill="false"
                                :placeholder="$t('property.create.info.zipcode')">
                        </div>
                        <div class="input-container">
                            <input
                                id="city"
                                type="text"
                                v-model="city"
                                class="form-control"
                                :class="{fill: city}"
                                name="city"
                                disabled
                                :placeholder="$t('property.create.info.city')">
                        </div>
                    </div>
                    <div class="row">
                        <div class="input-container">
                            <validation-provider rules="required" v-slot="{failed}" slim>
                                <input
                                    id="address"
                                    autocomplete="off"
                                    type="text"
                                    v-model="address"
                                    class="form-control"
                                    name="address"
                                    :disabled="!city.length"
                                    :placeholder="$t('property.create.info.address')"
                                    :class="{fill: city, 'has-error': failed}"
                                />
                            </validation-provider>
                            <div class="auto-complete" v-if="showAutocomplete" transition="fade">
                                <ul>
                                    <li v-for='address in autocompleteValues' @click='setAddressValue(address)'>
                                        {{ address.forslagstekst }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="warning">
                            <span v-if="showZipWarning">
                                {{ $t('property.create.info.zipcode-fail') }}
                            </span>
                        </div>
                    </div>
                    <div class="row">
                        <div v-if="getUserCompanies.length" class="form-group row">
                            <label for="isCompany" class="col-sm-4 col-form-label text-md-right">Is Company?</label>

                            <div class="col-md-6">
                                <input
                                    id="isCompany"
                                    type="checkbox"
                                    v-model="isCompany"
                                    class="form-control"
                                    name="isCompany"
                                />
                            </div>
                        </div>

                        <div class="form-group row" v-if="isCompany">
                            <label for="companies" class="col-sm-4 col-form-label text-md-right">Companies</label>

                            <div class="col-md-6">
                                <select name="companies" id="companies" v-model="company_id">
                                    <option v-for="company in getUserCompanies" :value="company.id">
                                        {{ company.company_name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <button type="submit" class="purple" disabled @click.prevent="addProperty">
                        {{ $t('property.create.button') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {store} from "../../store";
import {mapGetters} from "vuex";
import ChooseClient from '../../components/ChooseClient.vue';
import createEntity from "../../mixins/create-entity";
export default {
    mixins: [createEntity],
    created() {
        this.$root.$on('clientChosen', (id) => this.clientId = id);
        if (this.$route.query['client-id']) {
            this.showChooseClient = true;
        }
    },
    components: {
        ChooseClient
    },
    data: () => ({
        showChooseClient: false,
        zip_code: '',
        city: '',
        address: '',
        country: 'Denmark',
        isCompany: '',
        company_id: '',
        showZipWarning: false,
        autocompleteValues: [],
        createdId: false,
        clientId: false,
        dawa: {}
    }),
    computed: {
        ...mapGetters([
            'getToken',
            'getUserCompanies',
            'getAddProperty',
            'subscriptionIsUnlimited'
        ]),
        showAutocomplete() {
            return this.autocompleteValues.length > 1 ||
                (this.autocompleteValues.length > 0 && this.autocompleteValues[0].forslagstekst !== this.address);
        }
    },
    watch: {
        zip_code: function (val) {
            if (val.length < 4) {
                this.city = '';
                this.showZipWarning = false;
            }
            if (val.length > 4) {
                this.zip_code = val.slice(0, 4);
            }
            if (val.length === 4) {
                axios({
                    method: 'GET',
                    url: 'https://dawa.aws.dk/postnumre/' + this.zip_code,
                }).then(response => {
                    this.city = response.data.navn
                }).catch(e => {
                    this.showZipWarning = true
                });
            }
        },
        address: function (val) {
            if (this.city.length && val.length >= 3) {
                axios({
                    method: 'GET',
                    url: 'https://dawa.aws.dk/autocomplete?q=' + val + '&postnr=' + this.zip_code + '&fuzzy=true'
                }).then(response => {
                    this.autocompleteValues = [];
                    let self = this;
                    response.data.forEach(function (item) {
                        self.autocompleteValues.push(item);
                    })
                    if (this.autocompleteValues.length === 1 && this.autocompleteValues[0] === val) {
                        this.autocompleteValues = [];
                    }
                }).catch(e => {
                    this.showZipWarning = true
                });
            }
        }
    },
    mounted() {
        if (Object.keys(this.getAddProperty).length > 0) {
            this.zip_code = this.getAddProperty.zipcode;
            this.address = this.getAddProperty.address;
        }
    },
    methods: {
        addClient() {
            this.$store.commit('setAddProperty', {
                zipcode: this.zip_code,
                address: this.address
            });
            this.$router.push('/clients/?create=1&redirect=properties-add');
        },
        async addProperty() {
            var self = this;
            await axios({
                method: 'POST',
                url: this.$root.apiUrl + 'api/property/store',

                data: {
                    zip_code: this.zip_code,
                    city: this.city,
                    address: this.address,
                    country: this.country,
                    company_id: this.isCompany ? this.company_id : '',
                    clientId: this.showChooseClient ? this.clientId : false,
                    dawa: this.dawa
                }
            }).then(response => {
                self.$store.commit('setSuccessBarMessage', self.$t('successbar.properties.created.message'));
                self.createdId = response.data.id;
                this.$store.commit('resetAddProperty');
                store.dispatch('fetchProperties').then(
                    () => this.redirect()
                );
            });

        },
        redirect() {
            var self = this;
            var returnTo = this.$route.query.return;
            switch (returnTo) {
                case 'digital-contract':
                    let cloneId = this.$route.query.clone ? this.$route.query.clone : null;
                    let endpoint = window.config.apiUrl + 'api/draft-contract';

                    if(cloneId !== null) {
                        endpoint = window.config.apiUrl + 'api/draft-contract/' + cloneId + '/duplicate'
                    }

                    axios({
                        method: 'POST',
                        url: endpoint,
                        data: {
                            'property_id': this.createdId,
                        }
                    }).then(response => {
                        var id = response.data.draft_contract_id;
                        var url = '/contracts/digital-contract/edit/' + id;
                        this.$store.dispatch('fetchDraftContracts').then(() => {
                            this.$store.dispatch('fetchSingleDraftContract', id).then(() => {
                                this.$store.dispatch('fetchProperties').then(() => {
                                    this.$router.push(url);
                                });
                            });
                        });
                    });
                    break;
                case'custom-contract::create':
                    this.$router.push({name: 'custom-contract::create', params: {propertyId: this.createdId}});
                    break;
                case 'screening':
                    this.$router.push('/screenings/select-property?property=' + this.createdId);
                    break;
                case 'legacy-contract':
                    this.$router.push('/contracts/select-property?property=' + this.createdId);
                    break;
                default:
                    this.$router.push('/properties?newid=' + this.createdId);
            }
        },
        setAddressValue(address) {
            this.dawa = address;
            this.address = address.forslagstekst;
        },
    }
}
</script>

<style scoped>

</style>
